import { Divider, Typography } from "@mui/material";

import { FlightItem } from "@/typings";
import { getSeatsText } from "@/utils";

interface CabinInfoProps {
  data: FlightItem;
}

const cabinMapList = [
  "Economy",
  "Premium Economy",
  "Business",
  "First",
] as (keyof FlightItem["cabin_prices"])[];

const CabinInfoMobile = (props: CabinInfoProps) => {
  const { cabin_prices } = props.data;

  const renderCabinItem = (type: keyof FlightItem["cabin_prices"]) => {
    const cabinItem = cabin_prices?.[type];
    if (!cabinItem) {
      return null;
    }

    const seatsText = getSeatsText(cabinItem.seats);
    const isMixedCabin =
      cabinItem.premium_cabin_percentage > 0 && cabinItem.premium_cabin_percentage < 100;
    const premiumPercentage = Math.round(cabinItem.premium_cabin_percentage);
    return (
      <>
        <Divider className="mt-[100px] mb-[10px]" />
        <div className="mt-[10px] h-[45px]">
          <div className="flex justify-between">
            <Typography>{type}</Typography>
            <div className="flex items-center">
              <Typography>
                {cabinItem.miles / 1000} K + ${cabinItem.tax.toLocaleString()}
              </Typography>
            </div>
          </div>

          {seatsText && (
            <Typography fontSize={12}>
              {seatsText || "0"}
              {type !== "Economy" && premiumPercentage > 0 && ` • ${premiumPercentage}% Premium`}
            </Typography>
          )}
          {!seatsText && type !== "Economy" && (
            <Typography fontSize={12}>
              {premiumPercentage}% Premium
            </Typography>
          )}
        </div>
      </>
    );
  };

  return (
    <div>
      {cabinMapList.map((key, index) => (
        <div key={key}>{renderCabinItem(key)}</div>
      ))}
    </div>
  );
};
export default CabinInfoMobile;
